<div class="find-a-dentist">
  <div class="find-a-dentist-section">
    <div class="find-a-dentist-section__image">
      <img src="assets/dentist.svg" alt="Find a Dentist" />
    </div>

    <div class="find-a-dentist-section__content">
      <div class="find-a-dentist-section__title">{{ title }}</div>

      <div class="find-a-dentist-section__description">
        <p>Explore 70,000+ dentists nationwide in the network.</p>
        <p>
          Enjoy transparent pricing and save 25% to 85%<sup>†</sup> on major
          dental services with KELLS Complete Plan.
        </p>
      </div>

      <!-- <div
          class="find-a-dentist-section__upgrade-plan"
          *ngIf="isUpgradePlanVisible$ | async"
        >
          <button
            class="find-a-dentist-section__upgrade-plan-button"
            (click)="onUpgradePlanClick()"
          >
            <span class="find-a-dentist-section__upgrade-plan-button-text"
              >Upgrade plan</span
            >
            <img src="assets/bling_fill.svg" alt="Upgrade plan" />
          </button>
        </div> -->
    </div>

    <ng-container *ngIf="plan$ | async as plan">
      <div class="find-a-dentist-section__search">
        <a
          class="find-a-dentist-section__search-button"
          [href]="MEMBER_PROVIDERS_LINK"
          target="_blank"
          (click)="onSearchNowClick($event, plan)"
          >Search Now</a
        >
      </div>
    </ng-container>
  </div>
</div>
